var React = require('react');

function Telegram (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M12.2,219L115,257.4l39.8,128c2.5,8.2,12.6,11.2,19.2,5.8l57.3-46.7c6-4.9,14.6-5.1,20.8-0.6L355.7,419\r\n\t\tc7.1,5.2,17.2,1.3,19-7.3l75.8-364.4c1.9-9.4-7.3-17.2-16.2-13.8L12.1,196.3C1.6,200.3,1.7,215.1,12.2,219z M148.4,237.7l201-123.8\r\n\t\tc3.6-2.2,7.3,2.7,4.2,5.5L187.8,273.7c-5.8,5.4-9.6,12.7-10.7,20.6l-5.6,41.9c-0.8,5.6-8.6,6.1-10.1,0.7l-21.7-76.4\r\n\t\tC137.1,251.8,140.7,242.5,148.4,237.7z"})));
}

Telegram.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 455 455","style":{"enableBackground":"new 0 0 455 455"},"xmlSpace":"preserve"};

module.exports = Telegram;

Telegram.default = Telegram;
